import React from "react";
import { WrapWithGo } from "js-vextensions";
import ReactDOM from "react-dom";
import { OnPopulated } from "../../Manager.js";
export function StandardCompProps() {
    return ["dispatch", "_user", "_permissions", "_extraInfo"];
}
export function ElementAcceptsTextInput(element) {
    const elementType = element.tagName.toLowerCase();
    return (elementType == "textarea" ||
        (elementType == "input" && element.getAttribute("type") == "text"));
}
OnPopulated(() => {
    // patch React.createElement to do early prop validation
    // ==========
    const createElement_old = React.createElement;
    React["createElement"] = function (componentClass, props) {
        if (componentClass.ValidateProps) {
            componentClass.ValidateProps(props);
        }
        return createElement_old.apply(this, arguments);
    };
});
export const RunWithRenderingBatched = WrapWithGo((func) => {
    ReactDOM.unstable_batchedUpdates(func);
});
/* export class ExpensiveComponent_Options {
    simpleShouldUpdate_call? = true;
    simpleShouldUpdate_options?: Partial<SimpleShouldUpdate_Options> = new SimpleShouldUpdate_Options();
    warnOfTransientObjectProps_call? = true;
    warnOfTransientObjectProps_options?: Partial<WarnOfTransientObjectProps_Options> = new WarnOfTransientObjectProps_Options();
}
export function ExpensiveComponent(targetClass: Function);
export function ExpensiveComponent(options: Partial<ExpensiveComponent_Options>);
export function ExpensiveComponent(...args) {
    //Assert(targetClass instanceof Function, `Must decorate a class directly. (no "()" in "@ExpensiveComponent" line)`);
    //let options = new ExpensiveComponent_Options();
    let options = new ExpensiveComponent_Options();
    if (typeof args[0] == "function") {
        ApplyToClass(args[0]);
    } else {
        options = E(options, args[0]);
        return ApplyToClass;
    }

    function ApplyToClass(targetClass: Function) {
        if (options.simpleShouldUpdate_call) SimpleShouldUpdate(options.simpleShouldUpdate_options)(targetClass);
        if (options.warnOfTransientObjectProps_call) WarnOfTransientObjectProps(options.warnOfTransientObjectProps_options)(targetClass);
    }
} */ 
//# sourceMappingURL=General.js.map